<template>
    <div>
        <h3 class="font-semibold text-gray-700 text-md/none">{{ props.headline }}</h3>
    </div>
</template>

<script setup lang="ts">
type InternationalTooltipProps = {
    headline: string;
};

const props = defineProps<InternationalTooltipProps>();
</script>
